import React from "react";
import { observer } from "mobx-react";
import { toJS } from "mobx";
import { WeaTools, WeaLocaleProvider } from "ecCom";

import AdSearchInputItem from "./components/AdSearchInputtem";
import BrowserItem from "./components/BrowserItem";
import CascaderItem from "./components/CascaderItem";
import CheckboxItem from "./components/CheckboxItem";
import ColorPickerItem from "./components/ColorPickerItem";
import CustomFieldItem from "./components/CustomFieldItem";
import DateGroupItem from "./components/DateGroupItem";
import DatePickerItem from "./components/DatePickerItem";
import YearPickerItem from "./components/YearPickerItem";
import MonthPickerItem from "./components/MonthPickerItem";
import InputItem from "./components/InputItem";
import InputNumberItem from "./components/InputNumberItem";
import InputSearchItem from "./components/InputSearchItem";
import PeriodItem from "./components/PeriodItem";
import RangePickerItem from "./components/RangePickerItem";
import RichTextItem from "./components/RichTextItem";
import ScopeItem from "./components/ScopeItem";
import SelectGroupItem from "./components/SelectGroupItem";
import SelectItem from "./components/SelectItem";
import TagGroupItem from "./components/TagGroupItem";
import TextareaItem from "./components/TextareaItem";
import TimePickerItem from "./components/TimePickerItem";
import TimeRangePickerItem from "./components/TimeRangePickerItem";
import UploadItem from "./components/UploadItem";

import "./style/index.less";

const getLabel = WeaLocaleProvider.getLabel;
const getKey = WeaTools.getKey;
const types = WeaTools.types;

@observer
class Main extends React.PureComponent {
  render() {
    const { fieldConfig, form } = this.props;
    return this.renderComs(toJS(fieldConfig, true), form);
  }
  onChange = (key, args) => {
    let obj = {
      value: args[0] || ""
    };
    if (typeof args[0] === "number" || typeof args[0] === "boolean") {
      obj = {
        value: args[0]
      };
    }
    if (args[1]) obj.valueSpan = args[1];
    if (args[2]) obj.valueObj = args[2];
    let res = {};
    res[key] = obj;

    this.props.onChange && this.props.onChange(res, obj);
  };
  onBlur = (key, value) => {
    let obj = {
      value
    };
    let res = {};
    res[key] = obj;
    this.props.onBlur && this.props.onBlur(value, res, obj);
  };
  onSearch = (key, value) => {
    let obj = {
      value
    };
    let res = {};
    res[key] = obj;
    this.props.onSearch && this.props.onSearch(value, res, obj);
  };
  onEnterSearch = (key, value) => {
    let obj = {
      value
    };
    let res = {};
    res[key] = obj;
    // 支持input框onEnter事件走高级搜索的onSearch搜索方法
    const { onEnterSearch } = this.props;
    typeof onEnterSearch === "function" && onEnterSearch(value, res, obj);
  };

  renderComs(c, form) {
    //config obj text record index

    if (!c.conditionType) {
      // console && console.warn(c, `WeaSwitch渲染出错！ ${c.label} conditionType未定义`);
      console &&
        console.warn(
          c,
          `${getLabel(385069, "WeaSwitch渲染出错") +
            " " +
            c.label +
            " " +
            getLabel(385070, "conditionType未定义")}`
        );
      return <div className="wea-hide">{c.label}</div>;
    }
    const type = c.conditionType.toUpperCase();
    const key = getKey(c);
    const bindObj = form.$(key);
    // console.log('form', form, 'key', key, $(key), 'bindObj', bindObj);
    if (bindObj == undefined) {
      // console && console.warn(c, `WeaSwitch渲染出错！ ${c.label} conditionType未定义`);
      console &&
        console.warn(
          c,
          `${getLabel(385069, "WeaSwitch渲染出错") +
            " " +
            c.label +
            " " +
            getLabel(385070, "conditionType未定义")}`
        );
      return <div className="wea-hide">{c.label}</div>;
    }
    delete c.value;
    const { className } = this.props;
    if (className) c.className = className;
    if (type === types.INPUT) {
      return (
        <InputItem
          bindObj={bindObj}
          c={{ ...c }}
          itemKey={key}
          onChange={this.onChange}
          onBlur={this.onBlur}
          onEnterSearch={this.onEnterSearch}
        />
      );
    }

    if (type === types.PASSWORD) {
      return (
        <InputItem
          bindObj={bindObj}
          c={{ ...c }}
          itemKey={key}
          type="password"
          onChange={this.onChange}
          onBlur={this.onBlur}
          onEnterSearch={this.onEnterSearch}
        />
      );
    }

    if (type === types.BROWSER) {
      return (
        <BrowserItem
          bindObj={bindObj}
          c={{ ...c }}
          itemKey={key}
          onChange={this.onChange}
        />
      );
    }

    if (type === types.CHECKBOX) {
      return (
        <CheckboxItem
          bindObj={bindObj}
          c={{ ...c }}
          itemKey={key}
          onChange={this.onChange}
        />
      );
    }

    if (type === types.SWITCH) {
      return (
        <CheckboxItem
          bindObj={bindObj}
          c={{ ...c }}
          itemKey={key}
          onChange={this.onChange}
          type="switch"
        />
      );
    }

    if (type === types.DATEPICKER) {
      return (
        <DatePickerItem
          bindObj={bindObj}
          c={{ ...c }}
          itemKey={key}
          onChange={this.onChange}
        />
      );
    }

    if (type === types.TIMEPICKER) {
      return (
        <TimePickerItem
          bindObj={bindObj}
          c={{ ...c }}
          itemKey={key}
          onChange={this.onChange}
        />
      );
    }

    if (type === types.YEARPICKER) {
      return (
        <YearPickerItem
          bindObj={bindObj}
          c={{ ...c }}
          itemKey={key}
          onChange={this.onChange}
        />
      );
    }

    if (type === types.MONTHPICKER) {
      return (
        <MonthPickerItem
          bindObj={bindObj}
          c={{ ...c }}
          itemKey={key}
          onChange={this.onChange}
        />
      );
    }

    if (type === types.COLORPICKER) {
      return (
        <ColorPickerItem
          bindObj={bindObj}
          c={{ ...c }}
          itemKey={key}
          onChange={this.onChange}
        />
      );
    }

    if (type === types.SELECT) {
      return (
        <SelectItem
          bindObj={bindObj}
          c={{ ...c }}
          itemKey={key}
          onChange={this.onChange}
        />
      );
    }

    if (type === types.TEXTAREA) {
      return (
        <TextareaItem
          bindObj={bindObj}
          c={{ ...c }}
          itemKey={key}
          onChange={this.onChange}
          onBlur={this.onBlur}
        />
      );
    }

    if (type === types.DATE) {
      return (
        <DateGroupItem
          bindObj={bindObj}
          c={{ ...c }}
          itemKey={key}
          onChange={this.onChange}
        />
      );
    }

    if (type === types.SELECT_LINKAGE) {
      return (
        <SelectGroupItem
          bindObj={bindObj}
          c={{ ...c }}
          itemKey={key}
          onChange={this.onChange}
        />
      );
    }

    if (type === types.SCOPE) {
      return (
        <ScopeItem
          bindObj={bindObj}
          c={{ ...c }}
          itemKey={key}
          onChange={this.onChange}
        />
      );
    }

    if (type === types.TIMERANGEPICKER) {
      return (
        <TimeRangePickerItem
          bindObj={bindObj}
          c={{ ...c }}
          itemKey={key}
          onChange={this.onChange}
        />
      );
    }

    if (type === types.RANGEPICKER) {
      return (
        <RangePickerItem
          bindObj={bindObj}
          c={{ ...c }}
          itemKey={key}
          onChange={this.onChange}
        />
      );
    }

    if (type === types.CASCADER) {
      return (
        <CascaderItem
          bindObj={bindObj}
          c={{ ...c }}
          itemKey={key}
          onChange={this.onChange}
        />
      );
    }

    if (type === types.CASCADERCUSTOMFIELD) {
      return (
        <CustomFieldItem
          bindObj={bindObj}
          c={{ ...c }}
          itemKey={key}
          onChange={this.onChange}
        />
      );
    }

    if (type === types.INPUTNUMBER) {
      return (
        <InputNumberItem
          bindObj={bindObj}
          c={{ ...c }}
          itemKey={key}
          onChange={this.onChange}
          onBlur={this.onBlur}
        />
      );
    }

    if (type === types.INPUTSEARCH) {
      return (
        <InputSearchItem
          bindObj={bindObj}
          c={{ ...c }}
          itemKey={key}
          onChange={this.onChange}
          onBlur={this.onBlur}
          onSearch={this.onSearch}
        />
      );
    }

    if (type === types.PERIOD) {
      return (
        <PeriodItem
          bindObj={bindObj}
          c={{ ...c }}
          itemKey={key}
          onChange={this.onChange}
        />
      );
    }

    if (type === types.UPLOAD) {
      return (
        <UploadItem
          bindObj={bindObj}
          c={{ ...c }}
          itemKey={key}
          onChange={this.onChange}
        />
      );
    }

    if (type === types.RICHTEXT) {
      return (
        <RichTextItem
          bindObj={bindObj}
          itemKey={key}
          c={{ ...c }}
          onChange={this.onChange}
        />
      );
    }

    if (type === types.TAGGROUP) {
      return (
        <TagGroupItem
          bindObj={bindObj}
          c={{ ...c }}
          itemKey={key}
          onChange={this.onChange}
        />
      );
    }

    if (type === types.DESCRIPTION) {
      return (
        <div
          className="wea-discription-wrapper"
          dangerouslySetInnerHTML={{ __html: bindObj.value }}
        />
      );
    }
    return (
      // 高级搜索内input 回车直接搜索
      <AdSearchInputItem bindObj={bindObj} onEnterSearch={this.onEnterSearch} />
    );
  }
}

export default Main;



// WEBPACK FOOTER //
// ./comMobx/wea-switch/index.js